import { RenewalContract } from '@cp-mx/common';
import { RenewalOptionSelector } from './RenewalOptionSelector';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

const RENEWAL_CONTRACT_SESSION_KEY = 'renewalContractSelected';

export const useRenewalContract = () => {
    const dispatch = useDispatch();
    const renewalContractState = useSelector(RenewalOptionSelector) as RenewalContract;

    useEffect(() => {
        if (!renewalContractState?.contractNumber) {
            const stored = sessionStorage.getItem(RENEWAL_CONTRACT_SESSION_KEY);
            if (stored) {
                try {
                    const parsed: RenewalContract = JSON.parse(stored);
                    dispatch({ type: 'renewalContractSelected', data: parsed });
                } catch {
                    sessionStorage.removeItem(RENEWAL_CONTRACT_SESSION_KEY);
                }
            }
        }
    }, [renewalContractState?.contractNumber, dispatch]);

    return {
        renewalContractState,
        setRenewalContract: (contract: RenewalContract) => {
            sessionStorage.setItem(RENEWAL_CONTRACT_SESSION_KEY, JSON.stringify(contract));
            dispatch({ type: 'renewalContractSelected', data: contract });
        },
    };
};
